<footer class="site-footer">
  <div class="container-page">
    <div class="footer-grid">
      <div class="footer-brand">
        <img src="images/advanced-rent-logo-dark.png" alt="Advanced Rent" class="footer-logo h-7 w-auto" width="175" height="28" />
        <p>UK tenant referencing and rent guarantee insurance for letting agents and landlords. Authorised and regulated by the Financial Conduct Authority, FCA No. 728481.</p>
      </div>
      <div class="footer-col">
        <h4>Products</h4>
        <a routerLink="/tenant-referencing">Tenant Referencing</a>
        <a routerLink="/rent-guarantee-insurance">Rent Guarantee Insurance</a>
        <a routerLink="/hmo-rent-guarantee-insurance">HMO Rent Guarantee</a>
        <a routerLink="/deposit-replacement">Deposit Replacement</a>
        <a routerLink="/home-buyers-insurance">Home Buyers Insurance</a>
        <a routerLink="/home-sellers-insurance">Home Sellers Insurance</a>
      </div>
      <div class="footer-col">
        <h4>Company</h4>
        <a routerLink="/for-agents">For Letting Agents</a>
        <a routerLink="/contact">Contact Us</a>
        <a routerLink="/terms-and-conditions">Terms and Conditions</a>
        <a routerLink="/privacy-policy">Privacy Policy</a>
      </div>
      <div class="footer-col">
        <h4>Get in touch</h4>
        <a href="tel:01603558180">01603 558 180</a>
        <a href="mailto:info@advanced-rent.com">info&#64;advanced-rent.com</a>
        <a href="mailto:referencing@advanced-rent.com">referencing&#64;advanced-rent.com</a>
        <p style="margin-top: 14px; font-size: 0.78rem; color: var(--text-muted);">Advanced Rent Limited<br/>Unit 1c St Marys Court, Carlton Forehoe<br/>Norwich NR9 4AL</p>
      </div>
    </div>
    <div class="footer-bottom">
      <span>© {{ year }} Advanced Rent Limited. Company No. 7748894. FCA No. 728481</span>
    </div>
  </div>
</footer>
